export default __webpack_public_path__ + "static/media/012-chocolate box.92bd6d28.svg";